import { getInfom } from '@/api/user';
import { addressListAjax } from '@/api/baseMsg';
import { loading } from '../../common/loading';
import Pinyin from "../../utils/pinyin";
export default {
    name: "addressBook",
    data () {
        return {
            showPopFlag: false,
            //通讯录信息
            arrData: [{}],
            //通讯录
            addressData: [{
                letter: '',
                data: []
            }],
            //通讯录弹框
            showPopJson: {
                showPopFlag: false,
                data: [],
            },
            value:''
        }
    },
    created () {
        this.init();
    },
    props: {
        params: Object,
    },
    methods: {
        popupFunction (data) {
            this.showPopJson.data = [];
            this.addressList(data.split(",")[1])
        },
        onClickLeft () {
            this.$router.push('/');
        },
        init () {
            loading(true);
            this.addressListAjax();
        },
        //通讯录addressListAjax
        addressListAjax (inputData) {
            addressListAjax({
                 orgId:'0e2e73308abc4e3da95721bb821dc41e',
                 whether:1,
                 personName: inputData, 
                 personId: '',
                 pageIndex:0,
                 pageSize:10000,
                 }).then(res => {
                    this.arrData = res.data;
                    this.addressData = this.pySort(res.data);
                    loading(false);
            })
        },
        //个人详细信息
        addressList (personId) {
            addressListAjax({ 
                    orgId:'0e2e73308abc4e3da95721bb821dc41e',
                    whether:1,
                    personName: '', 
                    personId: personId ,
                    pageIndex:0,
                    pageSize:1000,
                }).then(res => {
                    this.showPopJson.data = []
                    if(res.data.length>0){
                        this.showPopJson.data.push(res.data[0]);
                    }
                this.showPopJson.showPopFlag = true;
            })
        },
        //通讯录方法
        pySort: function (arr) {
            var arrList = [];
            for (var m = 0; m < arr.length; m++) {
                arrList.push(arr[m].description + "," + arr[m].personId); //名字数组集合
            }
            var result = [];
            result = this.pinyinSort(arrList)
            return result;
        },
        onSearch (value) {
            this.addressListAjax(value);
        },
        pinyinSort (name) {
            var pinyinArray = new Array()
            for (var bukn = 0; bukn < name.length; bukn++) {
                var o = new Object()
                var ken = Pinyin.getSpell(name[bukn], function (charactor, spell) {
                    return spell[1];
                });
                o.description = name[bukn]
                o.pinyin = ken.split(',').join('')
                pinyinArray.push(o)
            }
            const map = {
                letter: '',
                data: []
            }
            pinyinArray.forEach((item) => {
                if (!map[item.pinyin[0].toUpperCase()]) {
                    map[item.pinyin[0].toUpperCase()] = {
                        letter: item.pinyin[0].toUpperCase(),
                        data: []
                    }
                }
                map[item.pinyin[0].toUpperCase()].data.push(
                    item.description,
                )
            }
            )
            var turn = new Array()
            var letters = "*0123456789ABCDEFGHIJKLNMOPQRSTUVWXYZ".split('');
            
            for (var i = 1; i < letters.length; i++) {
                if (map[letters[i]]) {
                    var obj = new Object()
                    obj.letter = letters[i]
                    obj.data = map[letters[i]].data
                    turn.push(obj)
                }
            }
            return turn;
        }
    },
    watch: {
        showPopFlag (newVal) {
            this.showPopFlag = newVal;
        }
    }
}
